import CloseIcon from '@mui/icons-material/Close';
import {
  ButtonProps,
  Dialog,
  DialogActions,
  DialogActionsProps,
  DialogContent,
  DialogProps,
  DialogTitle,
  IconButton,
} from '@mui/material';
import React, { MouseEventHandler, ReactNode } from 'react';
import { styled } from '@/theme/index';

export interface ModalProps extends DialogProps {
  children?: ReactNode | ReactNode[];
  onClose?: ((
    event: Event,
    reason: 'backdropClick' | 'escapeKeyDown'
  ) => void) &
    MouseEventHandler<HTMLButtonElement>;
  actions?: ReactNode[];
  hasCloseIcon?: boolean;
  actionsProps?: DialogActionsProps;
  closeButtonProps?: ButtonProps;
}

const StyledModalContainer = styled(Dialog)`
  .MuiBackdrop-root {
    background: rgba(255, 255, 255, 0.9);
  }
`;

const CloseModal = ({
  className,
  onClose,
}: {
  className?: ModalProps['className'];
  onClose: ModalProps['onClose'];
}) => (
  <IconButton
    children={<CloseIcon />}
    onClick={onClose}
    className={className}
  />
);

const StyledCloseModal = styled(CloseModal)`
  background-color: transparent;
  border: 0;
  font-weight: bold;
  cursor: pointer;
  position: absolute;
  top: 8px;
  right: 8px;
  z-index: 999;
`;

export const CardTitle = styled(DialogTitle)`
  margin-top: 20px;
  text-align: center;
  font-size: 24px;
`;

export const Modal: React.FC<ModalProps> = React.forwardRef(
  (
    {
      children: content,
      open,
      onClose,
      className,
      title,
      maxWidth,
      actions,
      hasCloseIcon,
      actionsProps,
      closeButtonProps,
      ...rest
    }: ModalProps,
    ref
  ) => {
    return (
      <StyledModalContainer
        className={className}
        open={open}
        onClose={onClose}
        maxWidth={maxWidth}
        ref={ref}
        {...rest}
      >
        {hasCloseIcon && (
          <StyledCloseModal onClose={onClose} {...closeButtonProps} />
        )}
        {title && <CardTitle id="modal-title">{title}</CardTitle>}
        <DialogContent>{content}</DialogContent>
        {actions && (
          <DialogActions sx={{ padding: '0 24px 24px 24px' }} {...actionsProps}>
            {actions}
          </DialogActions>
        )}
      </StyledModalContainer>
    );
  }
);
